
import { Badge } from "@/components/ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserRole } from "@/lib/types/auth";

interface UserRoleSelectProps {
  userId: string;
  currentRole: UserRole;
  onRoleChange: (userId: string, newRole: UserRole) => Promise<void>;
}

export function UserRoleSelect({ userId, currentRole, onRoleChange }: UserRoleSelectProps) {
  return (
    <Select
      defaultValue={currentRole}
      onValueChange={(value: UserRole) => onRoleChange(userId, value)}
    >
      <SelectTrigger className="w-[110px] font-subtitle border-accent-light/30">
        <SelectValue>
          <Badge 
            variant={currentRole === 'admin' ? 'primary-subtle' : currentRole === 'staff' ? 'accent' : currentRole === 'tech' ? 'secondary' : 'secondary'}
            className="font-subtitle"
          >
            {currentRole}
          </Badge>
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="font-subtitle border-accent-light/30">
        <SelectItem value="user">User</SelectItem>
        <SelectItem value="staff">Staff</SelectItem>
        <SelectItem value="admin">Admin</SelectItem>
        <SelectItem value="tech">Tech</SelectItem>
        <SelectItem value="superadmin">Superadmin</SelectItem>
      </SelectContent>
    </Select>
  );
}
